<div class="center cover">
  <img id="preview-cover" [src]="bookUrl ? bookUrl : '/assets/img/defaults/default_book_image_400w_simple.jpg'"/>
</div>
<div class="center upload">
  <button type="button" (click)="openFileChooseDialog()" class="btn invert">
    <!-- <img src="../../../assets/img/logos/cloud-upload.svg" alt="cloud upload" class="cloud-upload"/> -->
    <div class="upload-text">
      <ngx-file-drop dropZoneLabel="Upload Book Cover" (onFileDrop)="dropped($event)"
        (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"
        dropZoneClassName="upload-text" contentClassName="upload-text" browseBtnClassName="upload-text"
      >
      </ngx-file-drop>
    </div>
    <div class="upload-text-mobile">
      <ngx-file-drop dropZoneLabel="Update Cover" (onFileDrop)="dropped($event)"
          (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"
          dropZoneClassName="upload-text-mobile" contentClassName="upload-text-mobile" browseBtnClassName="upload-text-mobile"
      >
      </ngx-file-drop>
    </div>
  </button>
  <p>6x9 Ratio</p>
  <p class="accepted-text">Accepted file types: jpg, jpeg, gif, or png</p>
  <input type="file" #fileInput style="visibility: hidden" ngf-max-size="12MB" (change)="fileChanged($event)">
</div>
